import {
	SET_MELDOO_WEB_REPORTS,
	APPEND_MELDOO_WEB_REPORTS,
	SET_MELDOO_WEB_REPORT_DETAILS,
	SET_MELDOO_WEB_SEARCH_RESULTS,
	CLEAR_MELDOO_WEB_SEARCH_RESULTS,
	CLEAR_MELDOO_WEB_REPORTS,
	SET_MELDOO_WEB_SEARCH_RESULTS_DONE,
	APPEND_MELDOO_WEB_SEARCH_RESULTS,
	SET_MELDOO_WEB_SETTINGS,
	SET_MELDOO_WEB_CAPTCHA,
	SEND_NEW_MELDOO_WEB_REPORT_SUCCESS,
	SEND_NEW_MELDOO_WEB_REPORT_ERROR,
	RESET_SEND_NEW_MELDOO_WEB_REPORT_RESPONSE,
	SERVER_GET_MELDOO_WEB_REPORTS,
	SERVER_GET_MELDOO_WEB_REPORT_DETAILS,
	SERVER_GET_MELDOO_WEB_SEARCH_RESULTS,
	SERVER_GET_MELDOO_WEB_SETTINGS,
	SERVER_GET_MELDOO_WEB_CAPTCHA,
	SERVER_SEND_NEW_MELDOO_WEB_REPORT,
	SET_MELDOO_WEB_TYPES_BY_LOCATION,
	SERVER_GET_MELDOO_WEB_TYPES_BY_LOCATION,
	SET_MELDOO_WEB_TYPES_BY_ORGANISATIONKEY
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	reports: [],
	searchResults: [],
	reportDetails: {
		reportId: null, // Int
		latlng: {
			lat: null, // Float
			lng: null //
		},
		type: {
			id: null, // Int
			description: null // String
		},
		address: {
			zip: null, // Int
			city: null, // String
			street: null, // String
			neighborhood: null // String
		},
		insertDate: null, // String
		finishDate: null, // String
		status: null, // Int
		description: null, // String
		images: [],
		workflow: []
	},
	newReportCaptcha: null,
	settings: {
		colors: {
			body: { bg: '#f4f4f4', font: '#5c5c5c' },
			main: { bg: '#f3921b', font: '#fff' },
			accent: { bg: '#2f75ba', font: '#fff' },
			success: { bg: '#afca0b', font: '#fff' },
			grey: { bg: '#9e9e9e', font: '#fff' },
			error: { bg: '#c3292e', font: '#fff' },
			navigation: { bg: '#afca0b', font: '#fff', link: '#0f0' },
			steps: { stepDone: '#f3921b', stepOpen: '#9e9e9e' },
			next: { bg: '#f3921b', font: '#fff', hoverBg: '#F6B25F', hoverFont: '#fff' },
			previous: { bg: '#2f75ba', font: '#fff', hoverBg: '#6D9ECE', hoverFont: '#fff' },
			maps: { fill: '#000000', stroke: '#000000' }
		},
		modules: {
			reportCollection: true,
			reportSearch: false,
			reportDetails: true,
			newReport: true
		},
		reportCollection: {
			reportMap: true,
			reportList: true
		},
		reportSearch: {},
		reportDetails: {
			workflow: true
		},
		newReport: {},
		requirements: {
			description: { show: true, required: true },
			name: { show: true, required: true },
			email: { show: true, required: true },
			phone: { show: true, required: false }
		},
		types: [],
		organisationTypes: [],
		general: {
			headerImage: null,
			headerTitle: null,
			headerSubTitle: null,
			backgroundImage: null,
			mapCenter: { lat: null, lng: null },
			mapZoom: null,
			path: []
		}
	},
	sendNewReportError: null,
	sendNewReportSuccess: null,
	loading: {
		init: false,
		reports: false,
		searchResults: false,
		reportDetails: false,
		captcha: false,
		sendNewReport: false
	}
};

export default (state = INITIAL_STATE, action) => {
	//	console.log(action);
	switch (action.type) {
		case SET_MELDOO_WEB_SETTINGS:
			return { ...state, settings: action.payload.settings, loading: { ...state.loading, init: false } };
		case SET_MELDOO_WEB_TYPES_BY_LOCATION:
			return { ...state, settings: { ...state.settings, types: action.payload.types } };
		case SET_MELDOO_WEB_TYPES_BY_ORGANISATIONKEY:
			return { ...state, settings: { ...state.settings, types: action.payload.types } };
		case SET_MELDOO_WEB_REPORTS:
			return { ...state, reports: action.payload.reports, loading: { ...state.loading, reports: false } };
		case APPEND_MELDOO_WEB_REPORTS:
			return { ...state, reports: [...state.reports, ...action.payload.reports], loading: { ...state.loading, reports: false } };
		case SET_MELDOO_WEB_REPORT_DETAILS:
			return {
				...state,
				reportDetails: action.payload.reportDetails,
				loading: { ...state.loading, reportDetails: false }
			};

		case CLEAR_MELDOO_WEB_REPORTS:
			return {
				...state,
				reports: [],
				loading: { ...state.loading, reports: false }
			};

		case SET_MELDOO_WEB_SEARCH_RESULTS:
			return {
				...state,
				searchResults: action.payload.searchResults,
				loading: { ...state.loading, searchResults: false }
			};
		case CLEAR_MELDOO_WEB_SEARCH_RESULTS:
			return {
				...state,
				searchResults: [],
				loading: { ...state.loading, searchResults: false }
			};
		case SET_MELDOO_WEB_SEARCH_RESULTS_DONE:
			return {
				...state,
				loading: { ...state.loading, searchResults: false }
			};
		case APPEND_MELDOO_WEB_SEARCH_RESULTS:
			return {
				...state,
				searchResults: [...state.searchResults, ...action.payload.searchResults],
				loading: { ...state.loading, searchResults: false }
			};

		case SET_MELDOO_WEB_CAPTCHA:
			return {
				...state,
				newReportCaptcha: action.payload.captcha,
				loading: { ...state.loading, captcha: false }
			};
		case SEND_NEW_MELDOO_WEB_REPORT_SUCCESS:
			return {
				...state,
				sendNewReportSuccess: action.payload.message,
				loading: { ...state.loading, sendNewReport: false }
			};

		case SEND_NEW_MELDOO_WEB_REPORT_ERROR:
			return {
				...state,
				sendNewReportError: action.payload.message,
				loading: { ...state.loading, sendNewReport: false }
			};
		case RESET_SEND_NEW_MELDOO_WEB_REPORT_RESPONSE:
			return {
				...state,
				sendNewReportSuccess: null,
				sendNewReportError: null
			};
		case SERVER_GET_MELDOO_WEB_REPORTS:
			return {
				...state,
				loading: { ...state.loading, reports: true }
			};
		case SERVER_GET_MELDOO_WEB_REPORT_DETAILS:
			return {
				...state,
				loading: { ...state.loading, reportDetails: true }
			};
		case SERVER_GET_MELDOO_WEB_SEARCH_RESULTS:
			return {
				...state,
				loading: { ...state.loading, searchResults: true }
			};
		case SERVER_GET_MELDOO_WEB_SETTINGS:
			return { ...state, loading: { ...state.loading, init: true } };
		case SERVER_GET_MELDOO_WEB_TYPES_BY_LOCATION:
			return { ...state, loading: { ...state.loading } };
		case SERVER_GET_MELDOO_WEB_CAPTCHA:
			return { ...state, loading: { ...state.loading, captcha: true } };
		case SERVER_SEND_NEW_MELDOO_WEB_REPORT:
			return { ...state, loading: { ...state.loading, sendNewReport: true } };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/MeldooWeb.js